// extracted by mini-css-extract-plugin
export var defaultStyle = "Testimonial-module--defaultStyle--81da6";
export var testimonial = "Testimonial-module--testimonial--868ee";
export var testimonialHeading = "Testimonial-module--testimonialHeading--a37a5";
export var testimonialImage = "Testimonial-module--testimonialImage--ad00e";
export var testimonialQuoteContainer = "Testimonial-module--testimonialQuoteContainer--f76cc";
export var testimonialSource = "Testimonial-module--testimonialSource--30bdb";
export var testimonialTextContent = "Testimonial-module--testimonialTextContent--b50c4";
export var weddings = "Testimonial-module--weddings--efa96";